// DS1.7.3
import React from 'react';
import classnames from 'classnames';
import s from './MediaIndicator.scss';
function formatDuration(duration) {
    if (duration === void 0) { duration = 0; }
    if (!duration) {
        return null;
    }
    var seconds = duration % 60;
    var minutes = (duration - seconds) / 60;
    return "".concat(minutes, ":").concat(seconds < 10 ? "0".concat(seconds) : seconds);
}
var MediaIndicator = function (_a) {
    var type = _a.type, duration = _a.duration, className = _a.className;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        type === 'gif' && 'GIF',
        type === 'video' && formatDuration(duration)));
};
MediaIndicator.displayName = 'MediaIndicator';
export default MediaIndicator;
//# sourceMappingURL=MediaIndicator.js.map